<template>
  <require from="framework/html_behaviors/af-split"></require>
  <require from="controls/bs-nav-items"></require>

  <af-split view-model.ref="splitter">
    <div slot="panel1" style="height: 100%; overflow-x: hidden; overflow-y: auto;">
      <div class="mt-2 ml-2 mr-2 nav nav-tabs flex-wrap-reverse align-items-baseline ${reloading ? '--reloading' : ''}">
        <nav class="d-flex flex-wrap" as-element="bs-nav-items" navigation.bind="router.navigation" heading-icon="fas fa-map-marker-alt"></nav>
        <div class="ml-auto">
          <router-view class="btn-toolbar" name="toolbar"></router-view>
        </div>
      </div>
      <router-view name="list"></router-view>
    </div>
    <div slot="panel2" style="height: 100%;">
      <router-view name="map"></router-view>
    </div>
  </af-split>
</template>
